module.exports = __webpack_public_path__ + "img/slide01.4c4ea169.jpg";